import { combineReducers } from "redux";
import { reducer as libraryReducer } from "./library";

const sampleReducer = (
  state = {
    message: "combine reducers needs something... so this is a placeholder",
    more:
      "The idea is that you have full redux folders for each bit of the ui in here",
    more2: "Separate data from ui"
  },
  action
) => state;

const uiReducer = combineReducers({
  sample: sampleReducer,
  library: libraryReducer
});

export default uiReducer;
